<div class="dialog-box">
    <div class="mat-dialog-title" mat-dialog-title>
        <div id="lblHeading">
            Drawing Comparision
            <i class="fa fa-times-circle pull-right" (click)="togglePopupDialog()" aria-hidden="true"></i>
        </div>
    </div>
</div>
<div mat-dialog-content>
    <div class="eip-px-20 eip-pb-20 eip-pt-20">
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <EIPAutoComplete TextField="docTitle" ValueField="docId" WaterMarkText="Source Doc No" setId="sourceDoc"
                    ShowTextValueField='N' [dataSource]='dataSource' [IsCascading]='true'
                    (valueChange)='onselectedValueChange($event,true)'>
                </EIPAutoComplete>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <EIPAutoComplete #destinationDoc TextField="docTitle" ValueField="docId"
                    WaterMarkText="Destination Doc No" setId="destDoc" ShowTextValueField='N' [dataSource]='dataSource'
                    [IsCascading]='true' [defaultValue]="selectedDestinationDoc"
                    (valueChange)='onselectedValueChange($event,false)'>
                </EIPAutoComplete>
            </div>
        </div>
        <div class="row eip-pt-20 ml-0 mr-0">
            <div class="row justify-content-end flex-grow-1">
                <button class="btn btn-primary" id="btnCompare" (click)="compareDrawings()" [disabled]="!isCompareEnable()">Compare</button>
            </div>
        </div>
        <div class="row eip-pt-20">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <kendo-grid *ngIf="sourceFileGrid.length>0"  #sourceGrid [kendoGridBinding]="sourceFileGrid"
                    [selectable]="selectableSettings" id="sourceFileGridView" [sortable]="true" [resizable]="true"
                    [reorderable]="true" [selectable]="true" [scrollable]="true"
                    class="form-group-grid auto-complete-equal kg-hover-icon"
                    (selectionChange)="onSelectionChange($event,true)">
                    <ng-template kendoPagerTemplate>
                        <div class="k-pager-left">
                            <kendo-pager-info></kendo-pager-info>
                        </div>
                        <div class="k-pager-right">
                            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                            <kendo-pager-input></kendo-pager-input>
                            <kendo-pager-next-buttons></kendo-pager-next-buttons>
                        </div>
                    </ng-template>
                    <kendo-grid-checkbox-column showSelectAll="true" width="30">
                    </kendo-grid-checkbox-column>
                    <kendo-grid-column field="fileName" title="File Name" width="150">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.fileName}}" eipTooltipPosition="auto">
                                {{dataItem.fileName}}
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="revisionNo" title="Revision No" width="50">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.revisionNo}}" eipTooltipPosition="auto">
                                {{dataItem.revisionNo}}
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="createdOn" title="Created On" width="50">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.createdOn}}" eipTooltipPosition="auto">
                                {{dataItem.createdOn|date:'dd-MMM-yyyy'}}
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <kendo-grid *ngIf="destinationFileGrid.length>0" #destinationGrid [kendoGridBinding]="destinationFileGrid"
                    [selectable]="selectableSettings" id="destFileGridView" [sortable]="true" [resizable]="true"
                    [reorderable]="true" [selectable]="true" [scrollable]="true"
                    class="form-group-grid auto-complete-equal kg-hover-icon"
                    (selectionChange)="onSelectionChange($event,false)">
                    <ng-template kendoPagerTemplate>
                        <div class="k-pager-left">
                            <kendo-pager-info></kendo-pager-info>
                        </div>
                        <div class="k-pager-right">
                            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                            <kendo-pager-input></kendo-pager-input>
                            <kendo-pager-next-buttons></kendo-pager-next-buttons>
                        </div>
                    </ng-template>
                    <kendo-grid-checkbox-column showSelectAll="true" width="30">
                    </kendo-grid-checkbox-column>
                    <kendo-grid-column field="fileName" title="File Name" width="150">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.fileName}}" eipTooltipPosition="auto">
                                {{dataItem.fileName}}
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="revisionNo" title="Revision No" width="50">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.revisionNo}}" eipTooltipPosition="auto">
                                {{dataItem.revisionNo}}
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="createdOn" title="Created On" width="50">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="no-wrap" eipTooltip="{{dataItem.createdOn}}" eipTooltipPosition="auto">
                                {{dataItem.createdOn|date:'dd-MMM-yyyy'}}
                            </span>
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</div>